import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNoticeH32(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "33",
    height: "32",
    fill: "none",
    viewBox: "0 0 33 32",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m20.61 5.78-8.987 5.372a4.75 4.75 0 0 1-2.437.673H7.124a1.917 1.917 0 0 0-1.917 1.917v4c0 1.058.858 1.917 1.917 1.917h2.19c.762 0 1.512.183 2.188.533l9.188 4.768a1.25 1.25 0 0 0 1.684-1.172V6.92c0-.91-.94-1.511-1.764-1.14m-.676-1.339c1.825-.876 3.94.454 3.94 2.48v16.867c0 1.945-1.965 3.276-3.772 2.553l-.034-.014-3.861-2.003v.095a3.417 3.417 0 0 1-3.417 3.416h-.666a3.417 3.417 0 0 1-3.417-3.416v-3.26H7.124a3.417 3.417 0 0 1-3.417-3.417v-4a3.417 3.417 0 0 1 3.417-3.417h2.062a3.25 3.25 0 0 0 1.668-.46l9.049-5.409zM10.81 21.524l3.896 2.021v.874a1.917 1.917 0 0 1-1.917 1.916h-.666a1.917 1.917 0 0 1-1.917-1.916v-3.135q.313.09.604.24m15.98-6.327a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm-.643 4.919a.75.75 0 0 1 1.029-.257l2.5 1.5a.75.75 0 1 1-.772 1.286l-2.5-1.5a.75.75 0 0 1-.257-1.029m3.529-9.471a.75.75 0 1 0-.772-1.286l-2.5 1.5a.75.75 0 0 0 .772 1.286z",
    clipRule: "evenodd"
  }));
}
var IcNoticeH32 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNoticeH32));

export { IcNoticeH32 as I };
